
import { createSlice } from "@reduxjs/toolkit";

/* const initialState = {
  byId: {},
  status: "idle",
  error: null,
}; */



const initialState = {
  byId: {
    // Adding mock data here so the selector finds it immediately
    "1": {
      companyId: "1",
      name: "Bessemer Venture Partners",
      sector: "Venture Capital",
      location: "San Francisco, CA",
      reportingCurrency: "USD",
      description: "A leading venture capital firm.",
      ownership: {
        partners: ["John Doe", "Jane Smith"],
        boardRepresentative: "Jane Smith",
        fundFamily: "BVP X",
        vintageYear: "2021",
        grade: "A",
        rank: "1",
      },
      investment: {
        ownershipPct: "15",
        investedCapital: "5000000",
        currentReserves: "1000000",
        totalCapitalBudget: "6000000",
        currentValue: "12000000",
        realisedValue: "0",
      }
    }
  },
  status: "idle",
  error: null,
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    // 🔹 Used after GET /company/:id
    loadCompanySuccess(state, action) {
      const company = action.payload;
      state.byId[company.companyId] = company;
      console.log("🔴 loadCompanySuccess", action.payload);
    },

    // 🔹 Used after SAVE (edit flow)
    updateCompany(state, action) {
      const { companyId, updates } = action.payload;

      state.byId[companyId] = {
        ...state.byId[companyId], // keep existing
        ...updates,               // override changed fields
      };
      console.log("🟢 updateCompany", action.payload);
    },

    // Delete
    deleteCompany(state, action) {
      const companyId = action.payload;
      delete state.byId[companyId];

    },
  },
});

export const { loadCompanySuccess, updateCompany, deleteCompany } = companySlice.actions;
export default companySlice.reducer;
